export const ScanStages = {
    'loadSlides': 0,
    'setScanParams': 1,
    'scanning': 2,
}